/* unplugin-vue-components disabled */import { render } from "./ThemeSelector.vue?vue&type=template&id=0a1fbc73"
import script from "./ThemeSelector.vue?vue&type=script&lang=js"
export * from "./ThemeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_typescript@6.0.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__